import theme from '../../../lib/theme';
import { CoreBlockProps } from './CoreBlock';

const {
  layouts,
  scale,
  media,
  colors,
} = theme;

export default ({ brand }: CoreBlockProps) => ({
  container: {

    'h1, h2, h3, h4, h5': {
      color: `${colors[brand].primary} !important`,
    },
  },
});
